import { type ethers } from "ethers";

export const getChainIdFromProvider = async (
  provider: ethers.JsonRpcProvider | ethers.JsonRpcApiProvider,
) => {
  const network = await provider.getNetwork();

  return network.chainId;
};

export const getBlockTimestamp = async (
  provider: ethers.JsonRpcProvider | ethers.JsonRpcApiProvider,
  blockNumber: number,
) => {
  const block = await provider.getBlock(blockNumber);

  return block?.timestamp ?? 0;
};

export const findClosestBlockNumber = async (
  provider: ethers.Provider,
  date: Date,
) => {
  const timestamp = Math.floor(date.getTime() / 1000);
  let upperBlockNumber = await provider.getBlockNumber();
  let lowerBlockNumber = upperBlockNumber - 32767;

  while (lowerBlockNumber <= upperBlockNumber) {
    const midBlockNumber = Math.floor(
      (upperBlockNumber + lowerBlockNumber) / 2,
    );
    // console.log("Finding block number:", midBlockNumber);
    const midBlock = await provider.getBlock(midBlockNumber);

    if (!midBlock) {
      throw new Error("Failed to retrieve block");
    }

    if (midBlock.timestamp < timestamp) {
      lowerBlockNumber = midBlockNumber + 1;
    } else if (midBlock.timestamp > timestamp) {
      upperBlockNumber = midBlockNumber - 1;
    } else {
      return midBlockNumber; // 정확히 일치하는 타임스탬프를 찾았을 때
    }
  }

  // 정확한 일치를 찾지 못한 경우, 가장 근접한 블록 반환
  return lowerBlockNumber;
};
